import {
  useEvents
} from "./chunk-TFRVQL75.mjs";
import {
  HelpCenterEvents
} from "./chunk-AOTFDLGI.mjs";
import {
  useLayoutContext
} from "./chunk-HFINPXUM.mjs";

// src/internal/components/help-center-panel/help-center-ticket-created-footer.tsx
import { useAnalytics } from "@clara/events";
import { Button } from "@clara/button";
import { useT } from "@clara/locale";
import { Flex } from "@clara/ui";
import { jsx } from "react/jsx-runtime";
var HelpCenterTicketCreatedFooter = () => {
  const { sidePanel } = useLayoutContext();
  const { t } = useT("common");
  const analytics = useAnalytics();
  const { eventData } = useEvents();
  const onClose = () => {
    analytics.track(HelpCenterEvents.EXPERIENCE_HELPERSIDE_CLOSE, {
      ...eventData,
      action: "close"
    });
    sidePanel.onClose();
  };
  return /* @__PURE__ */ jsx(Flex, { gap: 2, children: /* @__PURE__ */ jsx(Button, { width: 208, onClick: onClose, children: t("helpCenter.panel.button.finish") }) });
};

export {
  HelpCenterTicketCreatedFooter
};
